import {
  Container,
  ImageContainer,
  TextContainer,
  Image,
  TitleContainer,
  ActionContainer,
  TextDownload,
} from './styled'
import { H4 } from 'views/components/UI/Text'
import noImg from 'assets/images/no-image.png'
import DownloadIcon from 'assets/icons/DownloadIcon'
import skillIcon from 'assets/images/icon-skills-card.png'
import betesaIcon from 'assets/images/icon-betesa-card.png'
import test360Icon from 'assets/images/icon-test360-card.png'
import DownloadPlanCard from './download-plan-card'
import { useTranslation } from 'react-i18next'

interface IProps {
  title: string
  link?: string
  type: 'betesa' | 'skills' | string
  onClick?: (user_id: number, test_id: number, user_test_id: number, type: string) => void
  user_id?: number
  test_id?: number
  user_test_id?: number
  style?: React.CSSProperties
  planToDownload?: boolean
  onClickPlan?: (user_id: number, test_id: number, user_test_id: number, type: string) => void
  processId?: number
  userName?: string
  setLoadingReport?: (value: boolean) => void
  disabled?: boolean
  onClickDisabled?: () => void
}
function Index(props: IProps) {
  const { t } = useTranslation()
  const {
    title,
    type,
    onClick = () => {},
    user_id: userId = 0,
    test_id: testId = 0,
    user_test_id: userTestId = 0,
    style,
    planToDownload = false,
    processId = 0,
    userName,
    setLoadingReport,
    disabled = false,
    onClickDisabled = () => {},
  } = props

  return (
    <Container style={style}>
      <ImageContainer>
        {type === 'betesa' && <Image src={betesaIcon} />}
        {type === 'skills' && <Image src={skillIcon} />}
        {type === '360' && <Image src={test360Icon} />}
        {type !== 'betesa' && type !== 'skills' && type !== '360' && <Image src={noImg} />}
      </ImageContainer>
      <TextContainer>
        <TitleContainer>
          <H4>{title || 'Inserte titulo'}</H4>
        </TitleContainer>
        <ActionContainer>
          <DownloadIcon />
          <TextDownload
            disabled={disabled}
            onClick={(event) => {
              if (disabled) {
                onClickDisabled()
                return
              }
              event.preventDefault()
              onClick(userId, testId, userTestId, type)
            }}
          >
            {t('global.common.downloadReportText')}
          </TextDownload>
        </ActionContainer>
        {planToDownload && (
          <DownloadPlanCard
            userName={userName}
            skillParam={userTestId}
            typeTest={type}
            processIdParam={processId}
            setLoadingReport={setLoadingReport}
          />
        )}
      </TextContainer>
    </Container>
  )
}

export default Index
